import services from '.'
import { IData, INotification } from '../@types'
import { getAxiosErrorMessage } from '../resources'

async function getAll(): Promise<Array<INotification> | undefined> {
  try {
    const devices = await services.api
      .get<IData<Array<INotification>>>('/notifications/all')
      .then(({ data }) => data?.data)

    return devices
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function update(data: Partial<INotification>): Promise<void> {
  try {
    await services.api.put<IData<INotification>>('/notifications', data)
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

export default { getAll, update }
